






































































import { ShowFinally, Message, openModal } from 'mycorems-app-shared';
import isGranted from '../auth/isGranted';
import HasTaskMixin from '../components/HasTaskMixin';
import { Account, AccountFilters, QPagination } from '../types';
import RouterLink from '../routing/RouterLink.vue';
import AccountType from './AccountType';
import repository from './account-repository';
import AccountServiceTags from './AccountServiceChips.vue';
import AccountUsersModal from './AccountUsersModal.vue';
import AccountSubscribersModal from './subscriber/AccountSubscribersModal.vue';

interface Data {
  accounts: Account[],
  pagination: QPagination,
  searchQuery: string | null,
}

export default HasTaskMixin.extend({
  props: {
    parentId: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      default: AccountType.CLIENT,
    },
    filters: {
      type: Object as () => AccountFilters,
      default() {
        return {};
      },
    },
  },
  data(): Data {
    return {
      accounts: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      searchQuery: null,
    };
  },
  watch: {
    parentId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
    pagination: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
    searchQuery: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    canView(): boolean {
      if (this.type === AccountType.CLIENT) {
        return isGranted('VIEW_CLIENTS');
      }
      if (this.type === AccountType.AGENCY) {
        return isGranted('VIEW_AGENCIES');
      }
      return false;
    },
    columns(): { name: string, label: string, align: string }[] {
      const columns = [
        {
          name: 'name',
          label: 'Client Name',
          align: 'left',
        },
        {
          name: 'contact',
          label: 'Primary Contact',
          align: 'left',
        },
        {
          name: 'services',
          label: 'Services',
          align: 'left',
        },
        {
          name: 'users',
          label: 'Client Users',
          align: 'center',
        },
      ];
      if (this.type === AccountType.CLIENT) {
        columns.splice(4, 0, {
          name: 'subscribers',
          label: 'Subscribers',
          align: 'center',
        });
      }
      return columns;
    },
    offset(): number {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage;
    },
  },
  methods: {
    openUsersModal(accountId: string): void {
      openModal(AccountUsersModal, { accountId });
    },
    openSubscribersModal(accountId: string): void {
      openModal(AccountSubscribersModal, { accountId });
    },
    add(account: Account): void {
      this.accounts.unshift(account);
    },
    load(offset: number = 0): void {
      const { filters } = this;
      filters.type = this.type;
      filters.offset = offset || this.offset;
      filters.limit = this.pagination.rowsPerPage;
      filters.name = this.searchQuery;
      this.task = repository.findAll(this.parentId, filters);
      this.task.then((result) => {
        this.accounts = result.items;
        this.pagination.rowsNumber = result.total;
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
  },
  components: {
    'account-service-tags': AccountServiceTags,
    'router-link': RouterLink,
    'show-finally': ShowFinally,
    message: Message,
  },
});
